import { Progress } from "antd";
import React from "react";

function IspPayCard() {
  return (
    <div className="mt-[1.25rem]">
      <div className="rounded-[.75rem] bg-[#F1F3F5] mt-[1rem] p-[1.25rem] font-interSans">
        <div className="flex lg:flex-row flex-col lg:items-center justify-between gap-y-[1.25rem]">
          <div className="flex flex-col gap-[1.25rem]">
            <span className="text-[#393939] font-interSans font-[400] text-[.875rem]">
            Amount Owned 
            </span>
            <span className="graph_h1 !text-[#1A1A1A]">400,267.00</span>
          </div>

          <div className="flex items-start gap-x-[2.5rem]">
            <div className="flex flex-col gap-[1.25rem]">
              <span className="text-[#393939] font-interSans font-[400] text-[.875rem]">
                Amount Paid (kes)
              </span>
              <span className="graph_h1 !text-[#1A1A1A]">100,267.00</span>
            </div>

            <Progress
              className="object-contain w-[3.625rem] h-[3.625rem]"
              type="circle"
              percent={"40"}
              strokeColor="#4FAD5B"
              width={60}
            />
          </div>
        </div>
      </div>
    </div>
  );
}

export default IspPayCard;
